import React, { useState, useEffect } from "react";
import "./ambitionslider.scss";
import Grid from "@mui/material/Grid2";
import { Container, Button, useMediaQuery } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useDispatch } from "react-redux";
import { setActiveIndex, show } from "../../redux/SideBarSlice";
import { setNav_Item } from "../../redux/NavBarSlice";
import { useNavigate } from "react-router-dom";
import { setActiveMenu, toggleMobileNavbar } from "../../redux/MobileSideBar";

const cards = [
  {
    id: 1,
    img: "/images/devops.webp",
    title: "Implementation & Deployment",
    desc: "Seamless rollout of Salesforce solutions tailored to your business needs.",
  },
  {
    id: 2,
    img: "/images/aa.webp",
    title: "Strategy & Consulting",
    desc: "Expert guidance to align Salesforce with your strategic business goals.",
  },
  {
    id: 3,
    img: "/images/a3.webp",
    title: "Customization & Development",
    desc: "Bespoke solutions built to extend Salesforce capabilities uniquely for you.",
  },
  {
    id: 4,
    img: "/images/4.webp",
    title: "Salesforce Org Assessment/Audit",
    desc: "Comprehensive evaluation to optimize performance and governance.",
  },
  {
    id: 5,
    img: "/images/5.webp",
    title: "Integration Services",
    desc: "Connect Salesforce seamlessly with your existing technology ecosystem.",
  },
  {
    id: 6,
    img: "/images/6.webp",
    title: "Document Generation Tool Integrations",
    desc: "Streamline workflows with Conga, Digio, and other document solutions.",
  },
  {
    id: 7,
    img: "/images/7.webp",
    title: "Slack-First Salesforce Solutions",
    desc: "Enhance collaboration with integrated Salesforce and Slack workflows.",
  },
  {
    id: 8,
    img: "/images/8.webp",
    title: "Managed Services & Support",
    desc: "Ongoing optimization and support to ensure continuous value delivery.",
  },
  {
    id: 9,
    img: "/images/9.webp",
    title: "Training & Adoption Services",
    desc: "Empower your teams with comprehensive Salesforce training programs.",
  },
];

const Ambitionslider = () => {
  const dispatch = useDispatch();
  const [startIndex, setStartIndex] = useState(0);
  const navigate=useNavigate()
  // MOBILE CHECK
  const isMobile = useMediaQuery("(max-width:768px)");

  // How many cards show at once
  const cardsPerSlide = isMobile ? 1 : 3;

  const totalSets = Math.ceil(cards.length / cardsPerSlide);
  const currentSet = Math.floor(startIndex / cardsPerSlide) + 1;

  const handleNext = () => {
    if (currentSet < totalSets) {
      setStartIndex((prev) => (prev + cardsPerSlide) % cards.length);
    }
  };

  const handlePrev = () => {
    if (currentSet > 1) {
      setStartIndex(
        (prev) => (prev - cardsPerSlide + cards.length) % cards.length
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentSet < totalSets) {
        handleNext();
      } else {
        setStartIndex(0);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [currentSet, totalSets, isMobile]);

  // Visible cards
  const visibleCards = [];
  for (let i = 0; i < cardsPerSlide; i++) {
    visibleCards.push(cards[(startIndex + i) % cards.length]);
  }

  const isAtStart = currentSet === 1;
  const isAtEnd = currentSet === totalSets;

  return (
    <div className="mambition">
      <Container>
        <Grid className="ambox">
          <Grid className="text">
            <h3>
              End-to-End Salesforce Solutions, <br /> Tailored to{" "}
              <span>Your Ambition </span>
            </h3>
            <p>
              From strategy to optimization, unlock your <br /> business’s full
              potential with Salesforce
            </p>
          </Grid>

          <Grid className="btns">
            <button
              className="btn1"
              onClick={() => {
                dispatch(show("services"));
                dispatch(setNav_Item("services"));
                dispatch(setActiveIndex(null));

                //! for mobile
                dispatch(toggleMobileNavbar())
                dispatch(setActiveMenu("services"))
              }}
            >
              EXPLORE SERVICES
            </button>
            <button className="btn2" onClick={()=>navigate("/talktoexpert")}>SCHEDULE A CALL</button>
          </Grid>

          {/* CARD SLIDER */}
          <Grid className="slidecard">
            {visibleCards.map((card, index) => (
              <Grid
                key={card.id}
                className={
                  index === (cardsPerSlide === 3 ? 1 : 0) ? "slides2" : "slides"
                }
              >
                <div
                  className={
                    index === (cardsPerSlide === 3 ? 1 : 0) ? "avbox2" : "avbox"
                  }
                >
                   <img  loading="lazy" src={card.img} alt={card.title} />
                </div>

                {/* Switch order only for desktop middle card */}
                {index === (cardsPerSlide === 3 ? 1 : 0) ? (
                  <>
                    <p>{card.desc}</p>
                    <h5>{card.title}</h5>
                  </>
                ) : (
                  <>
                    <h5>{card.title}</h5>
                    <p>{card.desc}</p>
                  </>
                )}
              </Grid>
            ))}
          </Grid>

          {/* NAVIGATION BUTTONS */}
          <Grid
            className="slider-buttons"
            sx={{
              textAlign: "center",
              mt: 3,
              display: "flex",
              position: "relative",
              bottom: "70px",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={handlePrev}
              disabled={isAtStart}
              sx={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                background: isAtStart ? "#d3d3d3" : "#ff8c00",
                color: isAtStart ? "#7a7a7a" : "#fff",
                mx: 1.5,
                minWidth: "0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: isAtStart ? "not-allowed" : "pointer",
                "&:hover": {
                  background: isAtStart ? "#d3d3d3" : "#e67e00",
                },
              }}
            >
              <ArrowBackIosIcon fontSize="small" sx={{ marginLeft: "10px" }} />
            </Button>

            <Button
              onClick={handleNext}
              disabled={isAtEnd}
              sx={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                background: isAtEnd ? "#d3d3d3" : "#ff8c00",
                color: isAtEnd ? "#7a7a7a" : "#fff",
                mx: 1.5,
                minWidth: "0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: isAtEnd ? "not-allowed" : "pointer",
                "&:hover": {
                  background: isAtEnd ? "#d3d3d3" : "#e67e00",
                },
              }}
            >
              <ArrowForwardIosIcon fontSize="small" />
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Ambitionslider;
